jQuery_T4NT(document).ready(function($) {

     /**
     * Variant selection changed
     */
	  $( document ).on( "variant:change", function( evt, variant ) {
	    //console.log( variant );
	  });

});
function adaptationFontSize(){
  let zoomVal = 1, $el, vwSize, unitVw, windowWidth = $(window).width();
  
  //兼容浏览器字体小于12px问题
  $(".image-with-text-pos-box").each(function(){
	$el = $(this).find(".image-with-text-pos-content");
  	vwSize = parseFloat($(this).get(0).style.fontSize.replace("px", ""))
    
    unitVw = windowWidth / 100;
    let zoomVal = parseFloat($(this).find(".image-with-text-pos-content").css('font-size').replace("px", "")) / 12;
    if(zoomVal <= 1){
		$el.css('zoom', vwSize * unitVw / 12);
    }  
  })
  
  // 产品页面宽度和当前窗口宽度比例
  let productDetailW = 0;
  if($('#wrap_des_pr').length > 0){
  	productDetailW = $('#wrap_des_pr').find(".banner-pos").first().width();
    console.log(productDetailW);
    $('#wrap_des_pr').find(".image-with-text-pos-content").css('font-size', (productDetailW/windowWidth*100) + '%');
  }
}

var entityMap = {
  "&": '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#39;',
  '/': '&#x2F;',
  '`': '&#x60;',
  '=': '&#x3D;'
};
 
function escapeHtml (string) {
  return String(string).replace(/[&<>"'`=\/]/g, function (s) {
    return entityMap[s];
});
}

function getProductHtml(){
    var html = "";
  $("#nt_content").find(".shopify-section").removeAttr("data-shopify-editor-section")
  $("#nt_content").find(".shopify-section:not(.type_faq):not(.type_instagram):not(.tool_btn)").each(function(){
    if($(this).hasClass("type_rich_text") && $(this).find(".pr-short-desc-wrap").length > 0){
    	html = html + $(this).find(".pr-short-desc-wrap").html();
    }else{
    	html = html + $(this).prop("outerHTML");
    }
  		
  	});
  
    $(".faqs-tabs-wrap").find(".shopify-tabs.sp-tabs").addClass("container");
    html = html + $(".faqs-tabs-wrap").html();
//     console.log(html);
  	html = html.replace(/lazyloadt4sed/g,"lazyloadt4s");
//   	html = html.replace(/lazyloading/g,"lazyload");
//   	html = html.replace(/src=/g, "nsrc=");
//   	html = html.replace(/data-nsrc/g, "data-src");
  
	document.getElementById('product-custom-html').innerHTML = escapeHtml(html);
}
function autoTextVideo(elem){
  var videoId = jQuery_T4NT(elem).data('video');
  var html = '<iframe class="youtube hide-player" src="https://www.youtube.com/embed/'+videoId+'?playsinline=1&rel=0&loop=1&autoplay=1&playlist='+videoId+'" frameborder="0" allowfullscreen="1" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"  width="640" height="360"></iframe>'
  jQuery_T4NT('#video-text-overlay').html(html);
  jQuery_T4NT(elem).fadeOut("normal");
}

jQuery_T4NT(document).ready(function($) {
	adaptationFontSize();
})
jQuery_T4NT(window).resize(function(){
	adaptationFontSize();
})